import React from 'react'

import { Skeleton } from '@mui/material'

import EnterpriseReportBox from './EnterpriseReportBox'
import Seats from './Seats'
import styles from './SignupsSection.module.scss'

interface SignupsSectionProps {
  loading: boolean
  totalSignups?: number
  userSignups?: Array<{
    email: string | null
    signupDate: any
    lastUsedDate?: any | null
  } | null>
  itemsPerPage?: number
}

export default function SignupsSection({
  loading,
  totalSignups,
  userSignups,
  itemsPerPage = 5,
}: SignupsSectionProps) {
  return (
    <EnterpriseReportBox
      header={
        <div className={styles.adoptionHeader}>
          <h2 className={styles.adoptionTitle}>Signups</h2>
          <div className={styles.adoptionCount}>
            {loading ? <Skeleton width={40} /> : totalSignups}
          </div>
        </div>
      }
      content={
        userSignups && (
          <Seats signups={userSignups} itemsPerPage={itemsPerPage} />
        )
      }
    />
  )
}
